/**
 * @export
 * @class RefundInfoLayer
 * 환불 정보 레이어
 */
export default class RefundInfoLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_refundInfoLayer';
    this.welPositioningWrap = $('#_wrapRefundInfo');

    this.setEvent();
    this.render();
    this.setPosition();
  }

  setEvent() {
    // 내용 더보기 eventListener 등록
    this.welContainer.on(
      'click',
      `#${this.sWrapper} [data-role=toggle]`,
      this.handleReadMore
    );
    // html protocol 변경으로 인해 beforeunload event를 발생시키는 것을 방지
    this.welContainer.on('click', `#${this.sWrapper} a`, () => {
      TMON.oApp.setStorage('bBlockWindowUnloadEvent', true);
    });
  }

  clearEvent() {
    this.welContainer.off('click', `#${this.sWrapper} [data-role=toggle]`);
    this.welContainer.off('click', `#${this.sWrapper} a`);
  }

  /**
   * 내용 더보기 eventListener
   * @param {object} e event 객체
   */
  handleReadMore(e) {
    $(e.currentTarget).toggleClass('show');
    $(e.currentTarget)
      .siblings('[data-role=toggleEl]')
      .toggle();
  }

  render = () => {
    const {
      htDealContentInfo: {
        bannerViewInfo: { hideUnusedRefundRate },
        contentInfo: { refundRule },
      },
    } = TMON.oApp.htStorage.htStaticData;

    const sHtml = `<article id="${this.sWrapper}" class="pop delivery_info">
                <div class="inner">
                    <div class="hd">
                       <h4>환불규정</h4>
                        <button type="button" data-role="close" class="close">
                            <span class="blind">닫기</span>
                        </button>
                    </div>
                    <div class="pop_ct overflow">
                        <dl class="delivery_info_detail">
                            <dt>미사용 티켓 환불 규정</dt>
                            <dd>
                                <ul class="lst_info">
                                    ${
                                      hideUnusedRefundRate === 0
                                        ? '<li>유효기간 종료일까지 사용해주세요.<br>유효기간 내에 사용하지 못한 티켓은 환불되지 않습니다.</li>'
                                        : `<li>유효기간 내 사용하지 못한 티켓은 구매 금액의 ${hideUnusedRefundRate}%를 티몬캐시/적립금으로 지급해드립니다.</li>
                                            <li>지급 수단 : 결제 형태에 따라 티몬캐시 또는 티몬 적립금으로 지급</li>
                                            <li>지급 일자 : 유효기간 종료 +6영업일 후</li>
                                            <li>사용 기간 : 지급일로부터 1년 (2021년 8월 31일 낮 12시 지급 건부터)</li>`
                                    }
                                </ul>
                            </dd>
                            ${
                              (TMON.htStaticData.bIsLocalDeal ||
                                TMON.htStaticData.bIsTourDeal) &&
                              refundRule
                                ? `<dt>취소/환불 규정</dt><dd>${refundRule}</dd>`
                                : ''
                            }
                        </dl>
                    </div>
                </div>
            </article>`;

    this.welContainer.append(sHtml);
  };

  setPosition = () => {
    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.setPositioningOnBasedElementOnPC({
        welBased: this.welPositioningWrap,
        welTarget: $(`#${this.sWrapper}`),
        nTop: 49,
        nRight: 0,
        nWidth: 400,
      });
    }
  };

  /**
   * 레이어 열기 함수
   */
  open = () => {
    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: false,
        bUseHistorybackOnClose: false,
        bShowDimmed: false,
      });
    } else {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
    }
  };
}
